import { render, staticRenderFns } from "./AccessorialsAndRateTable.vue?vue&type=template&id=0afb86f0&scoped=true"
import script from "./AccessorialsAndRateTable.vue?vue&type=script&lang=js"
export * from "./AccessorialsAndRateTable.vue?vue&type=script&lang=js"
import style0 from "./AccessorialsAndRateTable.vue?vue&type=style&index=0&id=0afb86f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afb86f0",
  null
  
)

export default component.exports